import { createSlice } from '@reduxjs/toolkit';

const initialState = { open: false, message: '', severity: 'success' };

const snackBarSlice = createSlice({
    name: 'snackBar',
    initialState: initialState,
    reducers: {
        initSnackbar: (state, action) => {
            return initialState;
        },
        setSnackbar: (state, action) => {
            return action.payload;
        },
        closeSnackbar: (state, action) => {
            state.open = false;
        },
    },
});

export const { initSnackbar, setSnackbar, closeSnackbar } = snackBarSlice.actions;
export default snackBarSlice.reducer;
